// UTF-8 sizes, for limits a server measures in bytes: accented letters take
// 2 bytes and some characters 4, so character counts undercount. Counted from
// code points rather than with TextEncoder, which jsdom (the test DOM) lacks.
const ONE_BYTE_LIMIT = 0x80;
const TWO_BYTE_LIMIT = 0x800;
const THREE_BYTE_LIMIT = 0x10000;

const utf8BytesOf = (character) => {
  const codePoint = character.codePointAt(0);

  if (codePoint < ONE_BYTE_LIMIT) return 1;
  if (codePoint < TWO_BYTE_LIMIT) return 2;
  if (codePoint < THREE_BYTE_LIMIT) return 3;

  return 4;
};

// for...of walks code points, so surrogate pairs (emoji) count once, as 4.
export const byteLength = (text) => {
  let bytes = 0;

  for (const character of text) {
    bytes += utf8BytesOf(character);
  }

  return bytes;
};

// Keeps whole characters, so a multi-byte character is never split.
export const truncateToBytes = (text, maxBytes) => {
  let truncated = "";
  let bytes = 0;

  for (const character of text) {
    bytes += utf8BytesOf(character);
    if (bytes > maxBytes) break;
    truncated += character;
  }

  return truncated;
};
